import * as Yup from 'yup';

export const preConferenceSchema = Yup.object()
  .shape({
    fullName: Yup.string().required('O nome é obrigatório'),
  })
  .required();
